<app-page titolo="Ruoli" [sottotitolo]="sottotitolo()">
  <button azioni type="button" mat-flat-button color="primary" (click)="new()">
    <mat-icon>add</mat-icon>
    Nuovo ruolo
  </button>

  <div class="filtri">
    <mat-form-field class="filtri__ricerca">
      <mat-label>Cerca nel nome o nel codice</mat-label>
      <input matInput [formControl]="filtroTesto" autocomplete="off" />
      @if (filtroTesto.value) {
        <button type="button" matSuffix mat-icon-button aria-label="Svuota la ricerca" (click)="azzeraFiltri()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <app-data-table
    [columnDefinitions]="columnDefinitions"
    [pageSizeOptions]="[25, 50]"
    [caricamento]="caricamento()"
    [errore]="errore()"
    [rigaCliccabile]="true"
    etichettaVuoto="Nessun ruolo."
    (rigaScelta)="edit($event)"
    (pageChange)="search(true)"
    (pageSizeChange)="search()"
    (sortChange)="search()"
    (onInit)="search()"
  />
</app-page>

<ng-template #codiceCella let-ruolo>
  <code class="codice-ruolo">{{ ruolo.code }}</code>
</ng-template>

<ng-template #azioniCella let-ruolo>
  <button type="button" mat-icon-button aria-label="Modifica" (click)="$event.stopPropagation(); edit(ruolo)">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>

<ng-template #detailsModal>
  <h2 mat-dialog-title>{{ editItem?.id ? 'Modifica ruolo' : 'Nuovo ruolo' }}</h2>

  <mat-dialog-content>
    <form class="modulo" [formGroup]="editItemForm">
      <mat-form-field class="modulo__largo">
        <mat-label>Nome del ruolo</mat-label>
        <input matInput formControlName="description" />
        <mat-hint>È il nome che si legge nel pannello.</mat-hint>
      </mat-form-field>

      <mat-form-field class="modulo__largo">
        <mat-label>Codice</mat-label>
        <input matInput formControlName="code" />
        <mat-hint>Lo usa il codice per decidere i permessi: owners, livello-2, livello-3.</mat-hint>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (editItem?.id) {
      <button type="button" mat-button class="modulo__elimina" (click)="elimina()">Elimina</button>
    }
    <span class="modulo__spazio"></span>
    <button type="button" mat-button mat-dialog-close>Annulla</button>
    <button type="button" mat-flat-button color="primary" (click)="save()">Salva</button>
  </mat-dialog-actions>
</ng-template>
